<template>
  <div v-if="loadingList">
    <div class="p-grid" id="loading">
      <div class="p-col-12" v-for="index in results.length || 5" :key="index">
        <Card>
          <template v-slot:content>
            <div class="p-grid">
              <div class="p-col-2" v-for="index in 12" :key="index">
                <Skeleton width="100%" height="23px" />
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>
  </div>
  <div v-else class="p-grid" v-for="service in results" :key="service.id">
    <div class="p-col-12">
      <router-link
        :to="getEditLink(service.id)"
        style="text-decoration: none"
        v-if="$ability.can('write', 'Service')"
      >
        <ServiceCard :service="service" />
      </router-link>
      <ServiceCard :service="service" v-else />
    </div>
  </div>
  <Paginator
    :rows="query.pageSize"
    :totalRecords="pagination.total"
    @page="changeListPage({ page: $event.page + 1 })"
  ></Paginator>
</template>

<script>
import useApiList from '../../../lib/useApiList';
import { ServiceApi } from '../../../services/api';
import ServiceCard from './ServiceCard.vue';

export default {
  name: 'ServiceListTable',
  components: {
    ServiceCard,
  },
  setup() {
    return {
      ...useApiList(ServiceApi),
    };
  },
  watch: {
    $route() {
      this.fetchList();
    },
  },
  async created() {
    await this.fetchList();
    this.$emitter.on('topbar-search', ({ query }) => {
      this.searchList({
        ...query,
        id: query.id || undefined,
        parentTypeId: query.parentTypeId || undefined,
        typeId: query.typeId || undefined,
        farmId: query.farmId || undefined,
        date: query.date || undefined,
        situation: query.situation || undefined,
        bovineValue: query.bovineValue || undefined,
        totalValue: query.totalValue || undefined,
        vetId: query.vetId || undefined,
        customerId: query.customerId || undefined,
        term: query.term || undefined,
      });
    });
  },
  methods: {
    getEditLink(id) {
      if ((this.$route.name || '').includes('customer')) {
        return { name: 'customer-service.edit', params: { id } };
      }
      return { name: 'service.edit', params: { id } };
    },
  },
};
</script>

<style scoped>
div >>> .p-datatable-wrapper {
  background: white;
}

#loading >>> .p-card-content {
  padding: 0 !important;
}
</style>
